// src/firebaseServiceWorker.js

// This will register the service worker once and export a promise that resolves to the registration.
export const serviceWorkerRegistration = (() => {
  if ('serviceWorker' in navigator) {
    return navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
        return registration;
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
        throw error;
      });
  } else {
    return Promise.reject(new Error('Service workers are not supported.'));
  }
})();
